import React from 'react';
import { useParams } from 'react-router-dom';
import { PatientSectionLayout } from './PatientSectionLayout';
import PatientNutritionProfileTab from './PatientNutritionProfileTab';

const PatientNutritionProfilePage: React.FC = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const numericPatientId = patientId ? Number(patientId) : NaN;
  const validId = !Number.isNaN(numericPatientId) && numericPatientId > 0;

  return (
    <PatientSectionLayout section="nutrition-profile">
      <section className="dashboard-section patient-tabs-section">
        {validId ? <PatientNutritionProfileTab patientId={numericPatientId} /> : null}
      </section>
    </PatientSectionLayout>
  );
};

export default PatientNutritionProfilePage;
